import { render, staticRenderFns } from "./SamplePopupCall.vue?vue&type=template&id=dda24bc2"
import script from "./SamplePopupCall.vue?vue&type=script&lang=js"
export * from "./SamplePopupCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dda24bc2')) {
      api.createRecord('dda24bc2', component.options)
    } else {
      api.reload('dda24bc2', component.options)
    }
    module.hot.accept("./SamplePopupCall.vue?vue&type=template&id=dda24bc2", function () {
      api.rerender('dda24bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SamplePopupCall.vue"
export default component.exports